import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useFormik } from "formik";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { getInputClasses, convertJsonToFormData, formatToUSDate } from "../../../helpers/helper";
import UserPersonalProfileInfoValidator from '../../../helpers/validators/UserPersonalProfileInfoValidator';
import * as userProfile from "../../../redux/userProfileOverviewRedux";
import Constants from "../../../constants/constants";
import { Button, Modal } from "react-bootstrap";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import * as userService from "../../../services/management/userService";
import * as alert from "../../../redux/alertSnackBarRedux";
import InputMask from "react-input-mask";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import DatePicker from 'react-datepicker';
import MaskedInput from 'react-maskedinput';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const PersonaInformation = (props) => {
  const { userProfileState, showAlert, updateUserProfile, auth, history } = props;
  const [loading, setloading] = useState(false);
  const [isSSSNUpdateModalOpen, setIsSSNUpdateModalOpen] = useState(false);
  const [savedSSN, setSavedSSN] = useState('');
  const [pic, setPic] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [avatar, setAvatar] = useState([]);
  const [signatureFile, setSignatureFile] = useState([]);
  const [signature, setSignature] = useState(null);
  const [initialValues, setInitialValues] = useState({
    id: 0,
    firstName: '',
    lastName: '',
    username: '',
    dateOfBirth: '',
    phoneNumber: '',
    email: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    signatureImageUrl: ''
  });

  useEffect(() => {
    if (userProfileState.id) {
      setForm();
    }
  }, [setForm, userProfileState]);

  const setForm = () => {
    userService.getPersonalInfo(userProfileState.id).then(res => {
      setInitialValues(res);
      setPic(`url(${Constants.API_URL + (userProfileState.imageUrl ? userProfileState.imageUrl : "Attachments/UserImages/blank.png")})`);
      setSignature((res.signatureImageUrl) ? Constants.API_URL + res.signatureImageUrl : null);
    })
  }

  const saveUser = (values, setStatus, setSubmitting) => {
    setloading(true);
    setSubmitting(true);
    userService.updatePersonalInformation(convertJsonToFormData({ ...values, signatureFile: signatureFile.length > 0 ? signatureFile[0].file : null })).then(res => {
      showAlert({ message: res.message, variant: "success" });
      updateUserProfile({ ...values, location: values.city, roles: userProfileState.roles });
    }).catch(ex => {
      showAlert({ message: ex.message, variant: "error" })
    }).finally(() => {
      setSubmitting(false);
      setloading(false);
    })
  };

  const handleModalClose = () => {
    setShowModal(false);
  }

  const UpdatePicture = () => {
    let pictureModel = {
      imageUrl: avatar[0].file,
      id: userProfileState.id
    }

    userService.updateUserAvatar(convertJsonToFormData(pictureModel)).then(res => {
      updateUserProfile({ ...userProfileState, imageUrl: res.imageUrl });
      setPic(`url(${Constants.API_URL + res.imageUrl}`);
      showAlert({ message: res.message, variant: "success" });
      handleModalClose();
    }).catch(ex => {
      showAlert({ message: ex.message, variant: "error" })
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: UserPersonalProfileInfoValidator,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      saveUser(values, setStatus, setSubmitting);
    }
  });

  const openSSNUpdateModal = () => {
    setloading(true);
    userService.getUserSSN(userProfileState.id).then(res => {
      setSavedSSN(res.ssn);
    }).catch(ex => {
      showAlert({ message: ex.message, variant: 'error' });
    }).finally(() => setloading(false));
    setIsSSNUpdateModalOpen(true);
  }

  const closeSSNUpdateModal = () => {
    setloading(false);
    setIsSSNUpdateModalOpen(false);
  }

  const updateSSN = () => {
    var trimmedSSN = savedSSN.replaceAll("-", "").replaceAll("_", "");
    if (trimmedSSN.length == 0 || trimmedSSN.length == 9) {
      setloading(true);
      userService.updateUserSSN(userProfileState.id, trimmedSSN).then(res => {
        setForm();
        showAlert({ message: res.message, variant: 'success' });
      }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))
        .finally(() => closeSSNUpdateModal());
      return;
    }

    showAlert({ message: "Please enter a valid SSN", variant: 'warning' });
  }

  return (
    <>
      <Modal show={isSSSNUpdateModalOpen} onHide={closeSSNUpdateModal}>
        {loading && <ModalProgressBar />}
        <Modal.Header closeButton>
          <Modal.Title>Update SSN for {userProfileState.firstName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
              SSN
            </label>
            <div className="col-lg-9 col-xl-6">
              <InputMask
                mask="999-99-9999"
                placeholder="123-45-6789"
                className={`form-control form-control-lg form-control-solid`}
                value={savedSSN}
                onChange={e => setSavedSSN(e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeSSNUpdateModal}>
            Close
          </Button>
          <Button variant="primary" onClick={updateSSN}>
            Update SSN
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Avatar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FilePond
            files={avatar}
            onupdatefiles={setAvatar}
            labelIdle='Drag & Drop image or <span class="filepond--label-action">Browse</span>'
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button disabled={avatar.length === 0} variant="primary" onClick={UpdatePicture}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <form
        className="card card-custom card-stretch"
        onSubmit={formik.handleSubmit}
      >
        {loading && <ModalProgressBar />}

        {/* begin::Header */}
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              Personal Information
            </h3>
            <span className="text-muted font-weight-bold fz-xs mt-1">
              Update personal information
            </span>
          </div>
          {
            auth.isAdmin ?
              <div className="card-toolbar">
                <button
                  type="submit"
                  className="btn btn-success mr-2"
                  disabled={
                    formik.isSubmitting || (formik.touched && !formik.isValid)
                  }
                >
                  Save Changes {formik.isSubmitting}
                </button>
                <a
                  onClick={() => history.goBack()}
                  className="btn btn-danger"
                >
                  Cancel
                </a>
              </div>
              : <></>
          }

        </div>
        {/* end::Header */}
        {/* begin::Form */}
        <div className="form">
          {/* begin::Body */}
          <div className="card-body">
            <div className="row">
              <label className="col-xl-3"></label>
              <div className="col-lg-9 col-xl-6">
                <h5 className="mb-6 fz-md fw-700 c-primary">Personal Info</h5>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">Avatar</label>
              <div className="col-lg-9 col-xl-6">
                <div
                  className="image-input image-input-outline"
                  id="kt_profile_avatar"
                >
                  <div
                    className="image-input-wrapper background-image-container"
                    style={{ backgroundImage: pic }}
                  />
                  {
                    auth.isAdmin ?
                      <label
                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                        data-action="change"
                        data-toggle="tooltip"
                        title=""
                        data-original-title="Change avatar"
                        onClick={() => setShowModal(true)}
                      >
                        <i className="fa fa-pen icon-sm text-muted"></i>
                      </label>
                      : <></>
                  }
                  <span
                    className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                    data-action="cancel"
                    data-toggle="tooltip"
                    title=""
                    data-original-title="Cancel avatar"
                  >
                    <i className="ki ki-bold-close icon-xs text-muted"></i>
                  </span>
                </div>
                <span className="form-text text-muted">
                  Allowed file types: png, jpg, jpeg.
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                First Name
              </label>
              <div className="col-lg-9 col-xl-6">
                <input
                  type="text"
                  disabled={!auth.isAdmin}
                  placeholder="First name"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "firstName")}`}
                  name="firstName"
                  {...formik.getFieldProps("firstName")}
                />
                {formik.touched.firstName && formik.errors.firstName ? (
                  <div className="invalid-feedback">
                    {formik.errors.firstName}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Last Name
              </label>
              <div className="col-lg-9 col-xl-6">
                <input
                  disabled={!auth.isAdmin}
                  type="text"
                  placeholder="Last name"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "lastName")}`}
                  name="lastName"
                  {...formik.getFieldProps("lastName")}
                />
                {formik.touched.lastName && formik.errors.lastName ? (
                  <div className="invalid-feedback">{formik.errors.lastName}</div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Username
              </label>
              <div className="col-lg-9 col-xl-6">
                <input
                  disabled={!auth.isAdmin}
                  type="text"
                  placeholder="JohnDoe07"
                  className={`form-control form-control-lg form-control-solid`}
                  name="username"
                  {...formik.getFieldProps("username")}
                  disabled
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Date of Birth
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <DatePicker
                    value={formik.getFieldProps("dateOfBirth").value ? formatToUSDate(formik.getFieldProps("dateOfBirth").value) : null}
                    dateFormat="MM/dd/yyyy"
                    selected={formik.getFieldProps("dateOfBirth").value ? new Date(formik.getFieldProps("dateOfBirth").value) : null}
                    customInput={
                      <MaskedInput
                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "dateOfBirth")}`}
                        mask="11/11/1111"
                        placeholder="MM/DD/YYYY"
                      />
                    }
                    onChange={(date) => {
                      formik.setFieldValue("dateOfBirth", formatToUSDate(date))
                    }}
                    onBlur={(e) => {
                      if (e.target.value.includes('_') || e.target.value === "") {
                        formik.setFieldValue("dateOfBirth", '')
                      }

                      formik.setFieldTouched('dateOfBirth');
                    }}
                  />
                </div>
                {formik.touched.dateOfBirth && formik.errors.dateOfBirth ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.dateOfBirth}
                  </div>
                ) : null}
              </div>
            </div>
            {
              auth.isAdmin &&
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                  Driver License Number
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div className="input-group input-group-lg input-group-solid">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className="fa fa-id-card"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      disabled={!auth.isAdmin}
                      placeholder="8565424"
                      className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "driverLicenseNumber")}`}
                      name="driverLicenseNumber"
                      {...formik.getFieldProps("driverLicenseNumber")}
                    />
                  </div>
                  {formik.touched.driverLicenseNumber && formik.errors.driverLicenseNumber ? (
                    <div className="invalid-feedback display-block">
                      {formik.errors.driverLicenseNumber}
                    </div>
                  ) : null}
                </div>
              </div>
            }
            {
              <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                  SSN
                </label>
                <div className="col-lg-9 col-xl-6">
                  <div className="input-group input-group-lg input-group-solid">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className="fa fa-shield-alt"></i>
                      </span>
                    </div>
                    <input
                      placeholder="SSN Info"
                      disabled
                      className={`form-control form-control-lg form-control-solid`}
                      value={formik.values.ssn}
                    />
                    {
                      auth.isAdmin ?
                        <div className="input-group-append">
                          <span
                            onClick={openSSNUpdateModal}
                            style={{ cursor: 'pointer' }}
                            className={`label label-xl label-inline label-light-danger`}
                          >
                            Click to view/update
                          </span>
                        </div>
                        : <></>
                    }

                  </div>
                  {formik.touched.ssn && formik.errors.ssn ? (
                    <div className="invalid-feedback display-block">
                      {formik.errors.ssn}
                    </div>
                  ) : null}
                </div>
              </div>
            }
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Signature
              </label>
              <div className="col-lg-9 col-xl-6">
                {
                  signature ?
                    <>
                      <img src={signature} />
                      <br />
                      <button className="btn btn-sm btn-primary" onClick={() => setSignature(null)}>Replace Signature</button>
                    </> :
                    <FilePond
                      labelIdle='Drag & Drop Signature Image of this User or <span class="filepond--label-action">Browse</span>'
                      onupdatefiles={setSignatureFile}
                      disabled={!auth.isAdmin}
                    />
                }
              </div>
            </div>
            <div className="row">
              <label className="col-xl-3"></label>
              <div className="col-lg-9 col-xl-6">
                <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Contact Info</h5>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Contact Phone
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-phone"></i>
                    </span>
                  </div>
                  <InputMask
                    disabled={!auth.isAdmin}
                    mask="(999) 999-9999"
                    type="text"
                    placeholder="(225)-000-0000"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "phoneNumber")}`}
                    name="phoneNumber"
                    {...formik.getFieldProps("phoneNumber")}
                  />
                </div>
                {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.phoneNumber}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Email Address
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-at.svg")} /> </span>
                    </span>
                  </div>
                  <input
                    type="email"
                    disabled={!auth.isAdmin}
                    placeholder="Email"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "email")}`}
                    name="email"
                    {...formik.getFieldProps("email")}
                  />
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="row">
              <label className="col-xl-3"></label>
              <div className="col-lg-9 col-xl-6">
                <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Address Info</h5>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Address 1
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-home"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="123 Second St."
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address1")}`}
                    name="address1"
                    {...formik.getFieldProps("address1")}
                  />
                </div>
                {formik.touched.address1 && formik.errors.address1 ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.address1}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Address 2
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-building"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="Apt# 1"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address2")}`}
                    name="address2"
                    {...formik.getFieldProps("address2")}
                  />
                </div>
                {formik.touched.address2 && formik.errors.address2 ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.address2}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                City
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-city"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="Baton Rouge"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "city")}`}
                    name="city"
                    {...formik.getFieldProps("city")}
                  />
                </div>
                {formik.touched.city && formik.errors.city ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.city}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                State
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-flag-usa"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    placeholder="Louisiana"
                    disabled={!auth.isAdmin}
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "state")}`}
                    name="state"
                    {...formik.getFieldProps("state")}
                  />
                </div>
                {formik.touched.state && formik.errors.state ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.state}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                Zip Code
              </label>
              <div className="col-lg-9 col-xl-6">
                <div className="input-group input-group-lg input-group-solid">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="fa fa-location-arrow"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={!auth.isAdmin}
                    placeholder="70809"
                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "zipCode")}`}
                    name="zipCode"
                    {...formik.getFieldProps("zipCode")}
                  />
                </div>
                {formik.touched.zipCode && formik.errors.zipCode ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.zipCode}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* end::Body */}
        </div>
        {/* end::Form */}
      </form>
    </>
  );
}

const mapStateToProps = (state) => ({
  userProfileState: state.userProfile,
  auth: state.auth
});


export default connect(mapStateToProps, {
  ...userProfile.actions,
  ...alert.actions
})(PersonaInformation);
